import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  ADD_NEW_TECHNICALADVISER,
  DELETE_TECHNICALADVISER,
  GET_TECHNICALADVISERS,
  UPDATE_TECHNICALADVISER,
  UPDATE_TECHNICALADVISER_CHECK,
  UPDATE_TECHNICALADVISER_STATUS
} from "./actionTypes";

import {
  addTechnicalAdviserFail,
  addTechnicalAdviserSuccess,
  deleteTechnicalAdviserFail,
  deleteTechnicalAdviserSuccess,
  getTechnicalAdvisersFail,
  getTechnicalAdvisersSuccess,
  setState,
  updateTechnicalAdviserCheck,
  updateTechnicalAdviserFail,
  updateTechnicalAdviserSuccess,
} from "./actions";

import { toast } from 'react-toastify';
import { technicalAdvisers, updateStatus } from "../../../helpers/adipiBackendUrl";
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";

function* fetchTechnicalAdvisers({ payload: { params } }) {
  try {
    yield put(setState(true));
    const response = yield call(getTable, technicalAdvisers, params.toString());
    yield put(setState(false));
    yield put(getTechnicalAdvisersSuccess(response.items, response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false));
    yield put(getTechnicalAdvisersFail(error));
  }
}

function* updateTechnicalAdviser({ payload: technicalAdviserObj }) {
  try {
    const { id, recordStatus, ...rest } = technicalAdviserObj;
    yield call(patchApiCall, `${technicalAdvisers}/${id}`, rest);
    const response = yield call(getTable, `${technicalAdvisers}/${technicalAdviserObj.id}`);
    yield put(updateTechnicalAdviserSuccess(response));
    toast.success('Registro actualizado correctamente');
  } catch (error) {
    yield put(updateTechnicalAdviserFail(error));
    toast.error('Error al actualizar el registro');
  }
}

function* updateTechnicalAdviserStatus({ payload: technicalAdviserObj }) {
  try {
    const { id } = technicalAdviserObj;
    yield call(patchApiCall, `${technicalAdvisers}/${updateStatus}/${id}`, { recordStatus: technicalAdviserObj.recordStatus });
    const response = yield call(getTable, `${technicalAdvisers}/${technicalAdviserObj.id}`);
    yield put(updateTechnicalAdviserSuccess(response));
  } catch (error) {
    yield put(updateTechnicalAdviserFail(error));
  }
}

function* deleteTechnicalAdviser({ payload: technicalAdviserObj }) {
  try {
    yield call(deleteApiCall, `${technicalAdvisers}/${technicalAdviserObj.id}`);
    yield put(deleteTechnicalAdviserSuccess(technicalAdviserObj.id));
    toast.success('Registro borrado correctamente');
  } catch (error) {
    yield put(deleteTechnicalAdviserFail(error));
    toast.error('Error al borrar el registro');
  }
}

function* postingTechnicalAdviser({ payload: technicalAdviser }) {
  try {
    const response = yield call(postApiCall, technicalAdvisers, technicalAdviser);
    const response2 = yield call(getTable, `${technicalAdvisers}/${response.id}`);
    yield put(addTechnicalAdviserSuccess(response2));
    toast.success('Registro agregado correctamente');
  } catch (error) {
    yield put(addTechnicalAdviserFail(error));
    toast.error('Error al agregar el registro');
  }
}

function* technicalAdvisersSaga() {
  yield takeEvery(GET_TECHNICALADVISERS, fetchTechnicalAdvisers);
  yield takeEvery(ADD_NEW_TECHNICALADVISER, postingTechnicalAdviser);
  yield takeEvery(UPDATE_TECHNICALADVISER, updateTechnicalAdviser);
  yield takeEvery(UPDATE_TECHNICALADVISER_STATUS, updateTechnicalAdviserStatus);
  yield takeEvery(DELETE_TECHNICALADVISER, deleteTechnicalAdviser);
  yield takeEvery(UPDATE_TECHNICALADVISER_CHECK, updateTechnicalAdviserCheck);
}

export default technicalAdvisersSaga;
